// src/services/collectionPointService.ts

import { supabase } from '../clients/supabaseClient';
import type { CollectionPoint } from '../types';

export type CreateCollectionPointPayload = {
    name: string;
    address_line1: string;
    suburb?: string | null;
    city?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    instructions?: string | null;
    is_active: boolean;
};

export type UpdateCollectionPointPayload = Partial<Omit<CreateCollectionPointPayload, 'is_active'>> & {
    is_active?: boolean;
};

export async function fetchCollectionPointsFromDb(): Promise<CollectionPoint[]> {
    const { data, error } = await supabase
        .from('collection_points')
        .select('*')
        .order('created_at', { ascending: true });

    if (error) throw error;
    return (data ?? []) as CollectionPoint[];
}

export async function createCollectionPointInDb(
    payload: CreateCollectionPointPayload
): Promise<CollectionPoint> {
    const { data, error } = await supabase
        .from('collection_points')
        .insert([payload])
        .select()
        .single();

    if (error) throw error;
    return data as CollectionPoint;
}

export async function updateCollectionPointInDb(
    id: string,
    patch: UpdateCollectionPointPayload
): Promise<CollectionPoint> {
    const { data, error } = await supabase
        .from('collection_points')
        .update({ ...patch, updated_at: new Date().toISOString() })
        .eq('id', id)
        .select()
        .single();

    if (error) throw error;
    return data as CollectionPoint;
}

export async function deleteCollectionPointFromDb(id: string): Promise<void> {
    const { error } = await supabase
        .from('collection_points')
        .delete()
        .eq('id', id);

    if (error) throw error;
}